import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import { OverlayTrigger } from 'react-bootstrap';
import tooltipRenderer from './tooltipRenderer';

const propTypes = {
    value: PropTypes.string.isRequired,
    row: PropTypes.shape({
        original: PropTypes.shape({
            roles: PropTypes.arrayOf(
                PropTypes.shape({
                    roleId: PropTypes.number.isRequired,
                    roleName: PropTypes.string.isRequired,
                })
            ),
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const defaultProps = {};

const MAX_LENGTH = 40;

function RolesCell({ value, row }) {
    const next = R.ifElse(
        /**
         * Check if a string and is less than the max length
         */
        R.allPass([R.is(String), R.compose(R.lt(R.__, MAX_LENGTH), R.prop('length'))]),
        R.identity,
        /**
         * Drop extra values and add the ellipse
         */
        R.compose(R.concat(R.__, '...'), R.join(', '), R.dropLast(1), R.split(', '), R.slice(0, MAX_LENGTH))
    )(value);

    const user = row.original;
    const { id, roles } = user;

    return (
        <OverlayTrigger placement="top" overlay={tooltipRenderer(id, roles)} delayShow={300}>
            <span>{next}</span>
        </OverlayTrigger>
    );
}

RolesCell.propTypes = propTypes;
RolesCell.defaultProps = defaultProps;

export default RolesCell;
